import React from "react";
import { Box, Grid, Typography } from "@mui/material";

const stats = [
    {
        title: "15+ Years",
        desc: "High-Value Sales Experience",
    },
    {
        title: "2000+ Crores",
        desc: "Transactional Sales Exposure",
    },
    {
        title: "1000+ Professionals",
        desc: "Professionals Mentored",
    },
    {
        title: "Multiple Industries",
        desc: "Product, Services, Luxury Segments",
    },
    {
        title: "Organisational Alignment",
        desc: "Individual Skill to Team Structure",
    },
];

const CoachTimeline: React.FC = () => {
    return (
        <Box
            sx={{

                color: "#fff",
                py: 5,
                px: { xs: 3, md: 10 },
                textAlign: "center",
            }}
        >
            {/* TITLE */}

            <Box sx={{ mb: 4 }}>
                <Typography
                    variant="h3"
                    component="span"
                    sx={{
                        color: "#fff",
                        fontSize: { xs: '30px', md: "35px" },
                        fontWeight: 700,
                        letterSpacing: 2,
                        mr: 1,
                    }}
                >
                    Meet Your
                </Typography>

                <Typography
                    variant="h1"
                    sx={{
                        background:
                            "linear-gradient(90deg, #ffffff 0%, #d4af37 100%)",
                        WebkitBackgroundClip: "text",
                        WebkitTextFillColor: "transparent",
                        position: "relative",
                        display: "inline-block",
                        fontWeight: 700,
                        fontSize: { xs: "50px", md: "auto" },
                        "&::after": {
                            content: '""',
                            position: "absolute",
                            bottom: "0px",
                            left: 0,
                            width: "100%",
                            height: "10px",
                            background: "rgb(177 177 177 / 50%)",
                            borderRadius: "4px",
                        },
                    }}
                >
                    Coach
                </Typography>
            </Box>

            {/* COACH CENTER */}
            <Box mb={6}>
                <Box
                    component="img"
                    src="https://dprstorage.b-cdn.net/RW/rwimage1.jpg"
                    sx={{
                        width: 150,
                        height: 150,
                        borderRadius: "50%",
                        border: "6px solid #0f63a5",
                        boxShadow: "0 0 30px rgba(15,99,165,0.6)",
                    }}
                />

                <Typography variant="h4" mt={2} fontWeight={700}
                    sx={{
                        color: 'white',

                    }}
                >
                    Rajiv Williams
                </Typography>

                <Typography sx={{ opacity: 0.8, color: 'white', }}>
                    Sales Strategist | High-Value Sales & Revenue Systems Mentor
                </Typography>
            </Box>

            {/* TIMELINE */}
            <Box position="relative" mb={10}>
                {/* MAIN LINE */}
                <Box
                    sx={{
                        height: "2px",
                        background: "#0f63a5",
                        width: "100%",
                        position: "absolute",
                        top: "0",
                    }}
                />

                <Grid container justifyContent="space-between">
                    {stats.map((item, index) => (
                        <Grid item xs={12} sm={6} md={2.4} key={index}>
                            {/* DOT */}
                            <Box
                                sx={{
                                    width: 16,
                                    height: 16,
                                    background: "#0f63a5",
                                    borderRadius: "50%",
                                    margin: "auto",
                                    marginTop: "-7px",
                                    boxShadow: "0 0 12px #0f63a5",
                                }}
                            />

                            {/* CONNECTOR */}
                            <Box
                                sx={{
                                    width: "2px",
                                    height: 30,
                                    background: "#0f63a5",
                                    margin: "auto",
                                }}
                            />

                            {/* CARD */}
                            <Box
                                sx={{
                                    background: "#050505",
                                    border: "1px solid #0f63a5",
                                    borderRadius: "14px",
                                    p: 3,
                                    mx: 1.5,
                                    height: 130,
                                    display: "flex",
                                    flexDirection: "column",
                                    justifyContent: "flex-start",
                                    textAlign: "center",
                                    boxShadow: "0 15px 35px rgba(0,0,0,0.6)",
                                    transition: "0.3s",

                                    "&:hover": {
                                        transform: "translateY(-6px)",
                                        boxShadow: "0 20px 40px rgba(15,99,165,0.5)",
                                    },
                                }}
                            >
                                {/* TITLE AREA (fixed height) */}
                                <Box
                                    sx={{
                                        height: 55,              // 🔥 keeps titles aligned
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                    }}
                                >
                                    <Typography
                                        variant="h6"
                                        fontWeight={700}
                                        sx={{
                                            background: "linear-gradient(90deg,#ffffff 0%,#d4af37 100%)",
                                            WebkitBackgroundClip: "text",
                                            WebkitTextFillColor: "transparent",
                                        }}
                                    >
                                        {item.title}
                                    </Typography>
                                </Box>

                                {/* DESCRIPTION AREA */}
                                <Typography
                                    sx={{
                                        opacity: 0.8,
                                        fontSize: 14,
                                        color: "white",
                                        mt: 2,
                                    }}
                                >
                                    {item.desc}
                                </Typography>
                            </Box>
                        </Grid>
                    ))}
                </Grid>
            </Box>
        </Box>
    );
}

export default CoachTimeline;